import EyeIconSVG from "assets/svg/eye-icon";
import Button from "components/button/button";
import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import TemplateFourPageTwo from "./template-four/page-two";
import TemplateFourPageOne from "./template-four/page-one";
import _ from "lodash";
import TemplateThreePageOne from "./template-three/page-one";
import TemplateThreePageTwo from "./template-three/page-two";
import TemplateFiveFullPageOne from "../full-preview/template-five/page-one";
import TemplateFiveFullPageTwo from "../full-preview/template-five/page-two";

/** TEAM/GROUP TEMPLATES */
import TemplateOneTG from "./template-one-tg";
import TemplateTwoPageOneTG from "./template-two-tg/page-one";
import TemplateThreePageOneTG from "./template-three-tg/page-one";
import TemplateFourPageOneTG from "./template-four-tg/page-one";
import { useHistory } from "react-router-dom";
import { TEMPLATE_NAME_1, TEMPLATE_NAME_2, TEMPLATE_NAME_3, TEMPLATE_NAME_4, TEMPLATE_NAME_5} from "constants/options";
import { useTranslation } from "react-i18next";
import html2canvas from 'html2canvas';
import { dataURLtoFile } from "utils/utils";
import { forwardRef, useImperativeHandle } from "react";
import { sortMilestones } from "utils/utils";
import { mergeArray, groupArraysWithType,A4_SIZE, LONG_SIZE } from "../resume";
import { applySharedBudget } from "utils/bio-limit";
import TemplateOneFull from "../full-preview/template-one";
import { LeftContent } from "../full-preview/template-one";
import { ItemMilestoneClone } from "./template-one-tg/item-milestone";
import TemplateTwoFullPageOne from "../full-preview/template-two/page-one";
import TemplateTwoFullPageTwo from "../full-preview/template-two/page-two";
import TemplateThreeFullPageOne from "../full-preview/template-three/page-one";
import TemplateThreeFullPageTwo from "../full-preview/template-three/page-two";
import TemplateFourFullPageOne from "../full-preview/template-four/page-one";
import TemplateFourFullPageTwo from "../full-preview/template-four/page-two";
import { useResume } from "redux/modules/resume/hooks";

const ResumePreview = forwardRef (({
  state = {},
  previewImage,
  milestones = {},
  primaryColor,
  secondaryColor,
  tertiaryColor,
  quarternary,
  page,
  setPage,
  setSelectedTab = () => {},
  profile,
},ref) => {
  const {t} = useTranslation()
  const history = useHistory();
  const itemRefs = React.useRef([]);
  const [totalPage, setTotalPage] = React.useState(2);
  const [mergeMilestone, setMergeMilestone] = React.useState([]);
  const cardRef = React.useRef();
  const { resumes } = useResume();
  // Live builder preview. Base it on the current edit buffer (state.more) so a
  // value the user just entered — e.g. a Date of Birth the profile itself
  // doesn't have — shows immediately. Then let the SAVED more_info win only
  // where it actually has a value, so saved fields still take priority over the
  // profile-seeded buffer, but a saved/empty birthdate can no longer clobber the
  // one just typed. (Marker.io MCF-1767)
  const moreInfo = React.useMemo(() => {
    const found = resumes?.find((item) => item.id === state.id);
    const merged = { ...(state?.more || {}) };
    const saved = found?.more_info || {};
    Object.keys(saved).forEach((k) => {
      const v = saved[k];
      if (v !== null && v !== undefined && v !== "") merged[k] = v;
    });
    // Cut the pooled text boxes (bio + Professional fields) to the template's
    // shared budget so the preview prints only what fits (MCF-637). Bio is cut
    // again at render via truncateBioForTemplate at the same budget, so the two
    // stay consistent.
    return applySharedBudget(merged, state.templateName);
  }, [resumes, state.id, state?.more, state.templateName]);

  const onChangePage = (staticPage, command) => {
    if (command === 'increment') {
      setPage(prev => {
        if (prev < totalPage) {
          return prev + 1;
        }
        return prev;
      });
    }

    if (command === 'decrement') {
      setPage(prev => {
        if (prev > 1) {
          return prev - 1;
        }
        return prev;
      });
    }
  };

  
  React.useEffect(() => { 
    if(state.templateName === TEMPLATE_NAME_5) return;
    const arraysWithType = [
      { array: sortMilestones(milestones?.featured) || [], type: 'featured' },
      { array: sortMilestones(milestones?.current) || [], type: 'current' },
      { array: sortMilestones(milestones?.past) || [], type: 'past' },
    ];
    if(state.templateName !== TEMPLATE_NAME_5){
      let groupAll;
      switch(state.templateName){
        case TEMPLATE_NAME_1:
          // Fit one more milestone per page — there was visible room for another.
          // (Marker.io MCF-1826)
          groupAll = groupArraysWithType(arraysWithType,7,7);
          break;
        case TEMPLATE_NAME_2:
          groupAll = groupArraysWithType(arraysWithType,6,6);
          break;
        case TEMPLATE_NAME_3:
          groupAll = groupArraysWithType(arraysWithType,7,7);
          break;
        case TEMPLATE_NAME_4:
          groupAll = groupArraysWithType(arraysWithType,8,8);
          break;
        default:
          groupAll = groupArraysWithType(arraysWithType,6,6);
      }
      console.log("Check Merge")
      console.log(groupAll)
      setMergeMilestone(groupAll)
      if(groupAll.length === 0){
        // No milestones selected: page 2 only carries the QR codes, so keep it
        // only when a QR code is actually shown there — otherwise it renders as a
        // blank second page. (Marker.io MCF-1825)
        const hasQrOnSecondPage = !!(state.show_qr_milestone || state.show_qr_reels);
        setTotalPage(hasQrOnSecondPage ? 2 : 1)
      }else{
        setTotalPage(groupAll.length + 1) // plus 1 for the fist page this is only for the individual;
      }
      return;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [milestones?.featured,milestones?.current, milestones?.past, state.templateName, state.show_qr_milestone, state.show_qr_reels]);


  const handleCapture = async () => {
    // if(cardRef.current){
    //   const canvas = await html2canvas(cardRef.current, {useCORS: true, allowTaint: true });
    //   const dataURL = canvas.toDataURL("image/png");
    //   const file_data = dataURLtoFile(dataURL, `screenshot-${state?.id}.png`);
    //   //  return file_data;
     
    //   return file_data
    // }
  };

  useImperativeHandle(ref, () => ({
    handleCapture,
  }));

  return (
    <div
      className={`w-full flex ${profile?.profile_type?.type === "group" || profile?.profile_type?.type === "team" ? " resume-tg" : ""}`}
      // Centre the fixed-width resume card in the grey preview column so the grey
      // padding around it is even on both sides. "safe center" centres it
      // whenever the column is wider than the card (every desktop width where the
      // uneven-gap problem actually shows) and automatically falls back to
      // left-aligned + horizontally scrollable when the column is narrower than
      // the card, so the card's left edge is never clipped. This replaces the
      // earlier lg:justify-center, which only kicked in at =1440px and so left
      // the card stuck to the left on 1165-1440px screens. (Marker.io MCF-1802)
      style={{ justifyContent: "safe center" }}>
      {/* Fit the block to the resume card (not the narrower 9sm cap) so centring
          it lines the card up evenly. */}
      <div className="w-fit max-w-full grid gap-y-6">
        <div className="w-full flex justify-between" >
          <Button
            buttonName={t("changeTemplate")}
            buttonTextClass="text-base font-semibold text-lightBlack"
            buttonRadius="6px"
            buttonClass="bg-template px-3.5 py-3.4"
            onClick={() => setSelectedTab("template")}
          />
          <Button
            buttonName={t("seeFullPreview")}
            buttonTextClass="text-base font-semibold text-primary flex flex-row items-center gap-x-2.5"
            buttonRadius="6px"
            buttonClass="bg-white px-3.5 py-3.4"
            onClick={() =>
              history.push(`/resume/preview`)
            }
            iconPosition="left"
            icon={<EyeIconSVG />}
          />
        </div>
        <div style={{
            width: 816 * 0.80,
            height: 1223 * 0.80,
          }}>
        <div className="relative" style={{...LONG_SIZE, transformOrigin: "top left", transform: "scale(0.80)"}}>
          {/* body */}
          {state.templateName === TEMPLATE_NAME_1 && (
            profile?.profile_type?.type === "group" || profile?.profile_type?.type === "team"
              ? 
              <div ref={cardRef}>
                <TemplateOneTG
                    {...{
                      page,
                      previewImage,
                      milestones,
                      primaryColor,
                      secondaryColor,
                      tertiaryColor,
                      profile,
                    }}
                    details={moreInfo}
                    personal={state.personal}
                    social={state.social}
                    show_image_milestone = {state.show_milestone_image}
                    show_qr_milestone = {state.show_qr_milestone}
                    show_qr_reels = {state.show_qr_reels}
                    milestone_position = {state.milestone_position}
                    setTotalPage={setTotalPage}
                  />
              </div>
                : 
                <>
                {
                  page === 1 && (
                    <div ref={cardRef}>
                      <TemplateOneFull
                        {...{
                          page:1,
                          previewImage,
                          milestones,
                          primaryColor,
                          secondaryColor,
                          tertiaryColor,
                          profile,
                          totalPage
                        }}
                        details={moreInfo}
                        personal={state.personal}
                        social={state.social}
                        show_image_milestone = {state.show_milestone_image}
                        show_qr_milestone = {state.show_qr_milestone}
                        show_qr_reels = {state.show_qr_reels}
                        hideOccupation={state.hideOccupation}
                        milestone_position = {state.milestone_position}
                        setTotalPage={setTotalPage}
                      
                      />
                    </div>
                  )
                }
                {
                  page > 1 && ( 
                      mergeMilestone.length > 0 ? mergeMilestone.map((item,index)=>{
                        return (
                        <>
                          {
                           page === (index+2) && 
                            <div className="mb-4" key={index}>
                              <TemplateOneFull
                                {...{
                                  item:item,
                                  page: index+2,
                                  previewImage,
                                  milestones,
                                  primaryColor,
                                  secondaryColor,
                                  tertiaryColor,
                                  profile,
                                  mergeMilestone,
                                  totalPage,
                                  show_qr_milestone:state.show_qr_milestone,
                                  show_qr_reels:state.show_qr_reels
                                }}
                                details={moreInfo}
                                personal={state.personal}
                                social={state.social}
                                totalPage={totalPage}
                                milestone_position = {state.milestone_position}
                                show_image_milestone = {state.show_milestone_image}
                              />
                            </div>
                          }
                        </>
                        )
                      }) :
                      <TemplateOneFull
                        {...{
                          item:[],
                          page:2,
                          previewImage,
                          milestones,
                          primaryColor,
                          secondaryColor,
                          tertiaryColor,
                          profile,
                          totalPage
                        }}
                        details={moreInfo}
                        personal={state.personal}
                        social={state.social}
                        show_image_milestone = {state.show_milestone_image}
                        show_qr_milestone = {state.show_qr_milestone}
                        show_qr_reels = {state.show_qr_reels}
                        hideOccupation={state.hideOccupation}
                        milestone_position = {state.milestone_position}
                        setTotalPage={setTotalPage}
                      
                      />
                  )
                }
                </>
                
          )}
          {state.templateName === TEMPLATE_NAME_2 && (
            <>
              {
                profile?.profile_type?.type === "group" || profile?.profile_type?.type === "team"
                  ? 
                  <div ref={cardRef}>
                    <TemplateTwoPageOneTG
                        {...{
                          page,
                          previewImage,
                          milestones,
                          primaryColor,
                          secondaryColor,
                          tertiaryColor,
                          quarternary,
                          profile,
                          totalPage
                        }}
                        color={state.color}
                        active={page === 1}
                        details={moreInfo}
                        personal={state.personal}
                        social={state.social}
                        show_image_milestone = {state.show_milestone_image}
                        setTotalPage={setTotalPage}
                        milestone_position = {state.milestone_position}
                      />
                  </div>
                    : <>
                    {page === 1 && <div ref={cardRef}>
                      <TemplateTwoFullPageOne
                        {...{
                          page,
                          previewImage,
                          primaryColor,
                          secondaryColor,
                          tertiaryColor,
                          quarternary,
                          profile,
                          milestones,
                          totalPage
                        }}
                        color={state.color}
                        active={page === 1}
                        details={moreInfo}
                        personal={state.personal}
                        social={state.social}
                        show_image_milestone = {state.show_milestone_image}
                        setTotalPage={setTotalPage}
                        hideOccupation={state.hideOccupation}
                        milestone_position = {state.milestone_position}
                      />
                    </div>}
                      {
                        page > 1 &&
                        (mergeMilestone.length > 0 ? mergeMilestone.map((item,index)=>{
                          return (
                            <>
                              {
                                page === (2+index) &&
                                <TemplateTwoFullPageTwo
                                  {...{
                                    item:item,
                                    page: index+2,
                                    previewImage,
                                    milestones,
                                    primaryColor,
                                    secondaryColor,
                                    tertiaryColor,
                                    quarternary,
                                    profile,
                                    totalPage
                                  }}
                                  color={state.color} 
                                  social={state.social}
                                  show_image_milestone = {state.show_milestone_image}
                                  setTotalPage={setTotalPage}
                                  show_qr_milestone = {state.show_qr_milestone}
                                  show_qr_reels = {state.show_qr_reels}
                                  milestone_position = {state.milestone_position}
                                  
                                />
                              }
                              
                            </>
                          )
                        }):
                        <TemplateTwoFullPageTwo
                            {...{
                              item:[],
                              page: 2,
                              previewImage,
                              milestones,
                              primaryColor,
                              secondaryColor,
                              tertiaryColor,
                              quarternary,
                              profile,
                              totalPage
                            }}
                            color={state.color} 
                            social={state.social}
                            show_image_milestone = {state.show_milestone_image}
                            setTotalPage={setTotalPage}
                            show_qr_milestone = {state.show_qr_milestone}
                            show_qr_reels = {state.show_qr_reels}
                            milestone_position = {state.milestone_position}
                          />)
                      }
                    </>
              }
              
            </>
          )}
          {/* {state.templateName === TEMPLATE_NAME_3 && (
            <>
              {
                profile?.profile_type?.type === "group" || profile?.profile_type?.type === "team"
                  ? 
                  <div ref={cardRef}>
                    <TemplateThreePageOneTG
                        {...{
                          page,
                          previewImage,
                          primaryColor,
                          secondaryColor,
                          tertiaryColor,
                          quarternary,
                          milestones,
                          profile,
                          totalPage
                        }}
                        color={state.color}
                        active={page === 1}
                        details={moreInfo}
                        personal={state.personal}
                        social={state.social}
                        setTotalPage={setTotalPage}
                        hideOccupation={state.hideOccupation}
                        milestone_position = {state.milestone_position}
                      />
                  </div>
                    : <>
                    {
                      page === 1 && (
                        <div ref={cardRef}>
                          <TemplateThreeFullPageOne
                          {...{
                            page,
                            previewImage,
                            primaryColor,
                            secondaryColor,
                            tertiaryColor,
                            quarternary,
                            profile,
                            milestones,
                            totalPage
                            }}
                            color={state.color}
                            active={page === 1}
                            details={moreInfo}
                            personal={state.personal}
                            social={state.social}
                            setTotalPage={setTotalPage}
                            hideOccupation={state.hideOccupation}
                            milestone_position = {state.milestone_position}
                          />
                        </div>
                      )
                    }
                      
                      {
                        page > 1 &&
                        mergeMilestone.map((item,index)=>{
                          return (
                            <>
                              {
                                page === (2+index) &&
                                  <TemplateThreeFullPageTwo
                                    {...{
                                      item:item,
                                      page: index+2,
                                      previewImage,
                                      milestones,
                                      primaryColor,
                                      secondaryColor,
                                      tertiaryColor,
                                      quarternary,
                                      totalPage
                                    }}
                                    color={state.color}
                                    active={page === 2}
                                    details={moreInfo}
                                    personal={state.personal}
                                    social={state.social}
                                    show_image_milestone = {state.show_milestone_image}
                                    setTotalPage={setTotalPage}
                                    show_qr_milestone = {state.show_qr_milestone}
                                    show_qr_reels = {state.show_qr_reels}
                                    milestone_position = {state.milestone_position}
                                  />
                              }
                            </>
                          )})
                        
                      }
                    </>
              }

            </>
          )} */}
          {state.templateName === TEMPLATE_NAME_4 && (
            <>
              {
                profile?.profile_type?.type === "group" || profile?.profile_type?.type === "team"
                  ? 
                  <div ref={cardRef}>
                    <TemplateFourPageOneTG
                        {...{
                          page,
                          totalPage,
                          previewImage,
                          primaryColor,
                          secondaryColor,
                          tertiaryColor,
                          quarternary,
                          milestones,
                          profile,
                        }}
                        color={state.color}
                        active={page === 1}
                        details={moreInfo}
                        personal={state.personal}
                        social={state.social}
                        setTotalPage={setTotalPage}
                        milestone_position = {state.milestone_position}
                      />
                  </div>
                    : <>
                    {
                      page === 1 && 
                      <div ref={cardRef}>
                        <TemplateFourFullPageOne
                          {...{
                            page,
                            totalPage,
                            previewImage,
                            primaryColor,
                            secondaryColor,
                            tertiaryColor,
                            quarternary,
                            profile,
                            milestones
                          }}
                          color={state.color}
                          active={page === 1}
                          details={moreInfo}
                          personal={state.personal}
                          social={state.social}
                          setTotalPage={setTotalPage}
                          hideOccupation={state.hideOccupation}
                          milestone_position = {state.milestone_position}
                        />
                      </div>
                    }
                      
                      {
                        page > 1 &&
                        (
                          mergeMilestone.length > 0 ? mergeMilestone.map((item,index)=>{
                          return (
                            <>
                              {
                                page === (2+index) &&
                                <TemplateFourFullPageTwo
                                  {...{
                                    item:item,
                                    page: index+2,
                                    previewImage,
                                    milestones,
                                    primaryColor,
                                    secondaryColor,
                                    tertiaryColor,
                                    quarternary,
                                    profile,
                                    totalPage
                                  }}
                                  color={state.color}
                                  active={page === 2}
                                  details={moreInfo}
                                  personal={state.personal}
                                  social={state.social}
                                  show_image_milestone = {state.show_milestone_image}
                                  setTotalPage={setTotalPage}
                                  show_qr_milestone = {state.show_qr_milestone}
                                  show_qr_reels = {state.show_qr_reels}
                                  milestone_position = {state.milestone_position}
                                />
                              }
                            </>
                          )
                        }):
                        <TemplateFourFullPageTwo
                          {...{
                            item:[],
                            page: 2,
                            previewImage,
                            milestones,
                            primaryColor,
                            secondaryColor,
                            tertiaryColor,
                            quarternary,
                            profile,
                            totalPage
                          }}
                          color={state.color}
                          active={page === 2}
                          details={moreInfo}
                          personal={state.personal}
                          social={state.social}
                          show_image_milestone = {state.show_milestone_image}
                          setTotalPage={setTotalPage}
                          show_qr_milestone = {state.show_qr_milestone}
                          show_qr_reels = {state.show_qr_reels}
                          milestone_position = {state.milestone_position}
                          
                        />
                      )
                      }
                    </>
              }
            </>
          )}
          {state.templateName === TEMPLATE_NAME_5 && (
            <>
              {
                profile?.profile_type?.type === "group" || profile?.profile_type?.type === "team"
                  ? 
                  <div ref={cardRef}>
                    <TemplateFiveFullPageOne
                        {...{
                          page,
                          totalPage,
                          previewImage,
                          primaryColor,
                          secondaryColor,
                          tertiaryColor,
                          quarternary,
                          milestones,
                          profile,
                        }}
                        color={state.color}
                        active={page === 1}
                        details={moreInfo}
                        personal={state.personal}
                        social={state.social}
                        setTotalPage={setTotalPage}
                        milestone_position = {state.milestone_position}
                        fullPreview={true}
                      />
                  </div>
                    : <>
                      <div ref={cardRef}>
                        {
                          page <= 1 &&
                          <TemplateFiveFullPageOne
                          {...{
                            page,
                            totalPage,
                            previewImage,
                            primaryColor,
                            secondaryColor,
                            tertiaryColor,
                            quarternary,
                            profile,
                            milestones
                          }}
                          color={state.color}
                          active={page === 1}
                          details={moreInfo}
                          personal={state.personal}
                          social={state.social}
                          setTotalPage={setTotalPage}
                          hideOccupation={state.hideOccupation}
                          milestone_position = {state.milestone_position}
                          fullPreview={true}
                          minHeight="305mm"
                        />
                        }
                      </div>
                      {
                        page >= 2 &&
                          <TemplateFiveFullPageTwo
                          {...{
                            page,
                            totalPage,
                            previewImage,
                            milestones,
                            primaryColor,
                            secondaryColor,
                            tertiaryColor,
                            quarternary,
                          }}
                          color={state.color}
                          active={page === 2}
                          details={moreInfo}
                          personal={state.personal}
                          social={state.social}
                          show_image_milestone = {state.show_milestone_image}
                          setTotalPage={setTotalPage}
                          show_qr_milestone = {state.show_qr_milestone}
                          show_qr_reels = {state.show_qr_reels}
                          milestone_position = {state.milestone_position}
                          fullPreview={true}
                        />
                      }
                    </>
              }
            </>
          )}
          {/* end body */}
          {/* start page */}
          <div className="w-full mt-2">
            {!_.isEmpty(state.templateName) && (
              <div className="w-full flex flex-row justify-between items-center">
                <p className="text-sm text-lightBlack font-semibold">
                  Page {page} of {totalPage}
                  {/* {
                  profile?.profile_type?.type === "group" || profile?.profile_type?.type === "team" ? totalPage : 2} */}
                  
                </p>
                <div className="flex flex-row space-x-2.5">
                  <button
                    className={`w-6 h-6 bg-lightBlack rounded-full flex items-center justify-center ${
                      page === 1 ? "opacity-40" : ""
                    }`}
                    onClick={() => onChangePage(1,'decrement')}>
                    <FaChevronLeft className="text-white margin-auto w-2.5 h-2.5" />
                  </button>
                  <button
                    className={`w-6 h-6 bg-lightBlack rounded-full flex items-center justify-center ${
                      page < totalPage ? "" : "opacity-40"
                    }`}
                    onClick={() => onChangePage(2,'increment')}>
                    <FaChevronRight className="text-white margin-auto w-2.5 h-2.5" />
                  </button>
                </div>
              </div>
            )}
          </div>
          {/* end page */}
        </div>
        </div>
        
      </div>
    </div>
  );
});

export default ResumePreview;
